import {
    apiRequest, 
    syaratJabatanList,
    syaratJabatanDetail,
    infoJabatan,
    positionTask,
    positionTaskUpdate,
    responsibility,
    responsibilityUpdate,
    authorityUpdate,
    Authority,
    detailPossesionRequisite,
    positionRequisiteUpdate,
    detailExperience,
    detailTraining,
    detailInterest

} from "../../../../../services/adapters/master/syaratJabatanService"

class UpdateRepository {

    fetchUpdate = async (query) => {
        return await apiRequest('post', positionTaskUpdate, {
            body: query
        }, true)
    }
    fetchUpdateTanggungjawab = async (query) => {
        return await apiRequest('post', responsibilityUpdate, {
            body: query
        }, true)
    }
    fetchUpdateWewenang = async (query) => {
        return await apiRequest('post', authorityUpdate, {
            body: query
        }, true)
    }
    fetchUpdateSyaratJabatan = async (query) => {
        return await apiRequest('post', positionRequisiteUpdate, {
            body: query
        }, true)
    }

    fetchPositionInfo = async (query, cancelToken) => {
        return await apiRequest('get', infoJabatan, {
            params: query,
            cancelToken: cancelToken
        }, true)
    }
    fetchInfoJabatan = async (query, cancelToken) => {
        return await apiRequest('get', infoJabatan, {
            params: query,
            cancelToken: cancelToken
        }, true)
    }
    fetchPositionTask = async (query, cancelToken) => {
        return await apiRequest('get', positionTask, {
            params: query,
            cancelToken: cancelToken
        }, true)
    }
    fetchResponsibility = async (query, cancelToken) => {
        return await apiRequest('get', responsibility, {
            params: query,
            cancelToken: cancelToken
        }, true)
    }
    fetchAuthority = async (query, cancelToken) => {
        return await apiRequest('get', Authority, {
            params: query,
            cancelToken: cancelToken
        }, true)
    }
    fetchRequisite = async (query, cancelToken) => {
        return await apiRequest('get', detailPossesionRequisite, {
            params: query,
            cancelToken: cancelToken
        }, true)
    }
    fetchExperience = async (query, cancelToken) => {
        return await apiRequest('get', detailExperience, {
            params: query,
            cancelToken: cancelToken
        }, true)
    }
    fetchTraining = async (query, cancelToken) => {
        return await apiRequest('get', detailTraining, {
            params: query,
            cancelToken: cancelToken
        }, true)
    }
    fetchInterest = async (query, cancelToken) => {
        return await apiRequest('get', detailInterest, {
            params: query,
            cancelToken: cancelToken
        }, true)
    }
 
}

export default UpdateRepository
